import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'semantic-ui-react'
import * as R from 'ramda'

const ActivationError = ({ isError }) =>
  isError ? (
    <div className="ui negative message">
      <div className="content">
        <div className="header">Authentication Unsuccessful</div>
        <p>Please double check your credentials and try again.</p>
      </div>
    </div>
  ) : null

ActivationError.propTypes = {
  isError: PropTypes.bool,
}

export class InfusionsoftAuthenticationModal extends React.Component {
  hiddenSubmitButtonRef = React.createRef()

  render() {
    const { isCredentialError, defaultValue, handleClose, loading, onSubmit } = this.props
    return (
      <React.Fragment>
        <Modal.Header>Authenticate with Infusionsoft</Modal.Header>
        <Modal.Content>
          <ActivationError isError={isCredentialError} />
          <p>
            To authenticate, enter the username and password you use to login to your Infusionsoft
            account.
          </p>
          <form
            className="ui form"
            onSubmit={(e) => {
              e.preventDefault()
              onSubmit(
                R.pipe(
                  R.pick(['account', 'access_key']),
                  R.evolve({ account: (el) => el.value, access_key: (el) => el.value })
                )(e.target.elements)
              )
            }}
          >
            <div className="two fields">
              <div className="field">
                <label>Account</label>
                <input
                  required
                  type="text"
                  name="account"
                  placeholder="ex: zy123"
                  defaultValue={defaultValue.username}
                  key={defaultValue.username}
                />
              </div>
              <div className="field">
                <label>Access key</label>
                <input
                  required
                  type="password"
                  name="access_key"
                  placeholder="ex: 2369a2c4c7b14323a977c646642dc230"
                  defaultValue={defaultValue.password}
                  key={defaultValue.password}
                />
              </div>
            </div>
            <input ref={this.hiddenSubmitButtonRef} type="submit" hidden />
          </form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            primary
            disabled={loading}
            loading={loading}
            onClick={() => this.hiddenSubmitButtonRef.current.click()}
          >
            Authenticate
          </Button>
        </Modal.Actions>
      </React.Fragment>
    )
  }
}

InfusionsoftAuthenticationModal.propTypes = {
  isCredentialError: PropTypes.bool,
  defaultValue: PropTypes.object.isRequired,
  handleClose: PropTypes.func,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}

InfusionsoftAuthenticationModal.defaultProps = {
  defaultValue: {},
  onSubmit: () => {},
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/InfusionsoftAuthenticationModal/index.js